import { Dispatch, SetStateAction, useState } from 'react';
import { ActiveFilters, ACTIVE_FILTER_DELIMITER, IFilter } from '../../filter-and-sort/filter';
import { ControlledCheckBox } from '../../controlled-inputs/checkbox';
import { FilterAndSorterRendererProps } from '../../filter-and-sort/FilterAndSorterRendererProps';
import ArrowDownSLineIcon from 'remixicon-react/ArrowDownSLineIcon';
import ArrowUpSLineIcon from 'remixicon-react/ArrowUpSLineIcon';

export type FilterAndSortProps<T> = {
  activeFilters: ActiveFilters;
  setActiveFilters: Dispatch<SetStateAction<ActiveFilters>>;
  filters: Array<IFilter<T>>;
};

const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export function VersatileFilterAndSortRenderer<T>({
  filters,
  activeFilters,
  toggleFilter,
}: // clearAllFilters,
FilterAndSorterRendererProps<T>) {
  const [wholeFilterGroup, setWholeFilterGroup] = useState<string>();
  return (
    <div>
      {filters.map((filterCategory, idx) => {
        return (
          <div key={idx}>
            <div className="text-title-7 mt-4 font-bold">{toTitleCase(filterCategory.groupName)}</div>
            <div className="mt-1 flex flex-col gap-1">
              {filterCategory.filterGroup.map((filter, idx) => {
                const filterIdentifer = filterCategory.groupName + ACTIVE_FILTER_DELIMITER + filter.value;
                return (
                  idx < (filterCategory.groupName === wholeFilterGroup ? filterCategory.filterGroup.length : 3) && (
                    <div className="flex gap-2" key={idx}>
                      <div className="grid place-items-center">
                        <ControlledCheckBox
                          id={filter.displayName}
                          checked={activeFilters.has(filterIdentifer)}
                          onChange={() => {
                            toggleFilter(filterIdentifer);
                          }}
                          aria-label={filter.displayName}
                        />
                      </div>
                      <div className="text-body-1 font-normal">{filter.displayName}</div>
                    </div>
                  )
                );
              })}
            </div>
            <div
              onClick={() =>
                setWholeFilterGroup((prevFilterGroupName) =>
                  prevFilterGroupName === filterCategory.groupName ? '' : filterCategory.groupName,
                )
              }
              className="text-primary mt-1 flex cursor-pointer gap-2 font-medium"
            >
              <div className="mt-[2px]">
                {filterCategory.groupName !== wholeFilterGroup ? <ArrowDownSLineIcon /> : <ArrowUpSLineIcon />}
              </div>
              {filterCategory.groupName !== wholeFilterGroup ? 'See More' : 'See Less'}
            </div>
          </div>
        );
      })}
    </div>
  );
}
